import React from 'react';

const BoxStoreContext = React.createContext('empty');

export default BoxStoreContext;
